import { render } from "./PixCashinEntryDetailsDialog.vue?vue&type=template&id=6605516f"
import script from "./PixCashinEntryDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PixCashinEntryDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__